import { render, staticRenderFns } from "./StoresMap.vue?vue&type=template&id=2cc30816&"
import script from "./StoresMap.vue?vue&type=script&lang=js&"
export * from "./StoresMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports